import * as actions from './inventoryRack/actions'
import * as mutations from './inventoryRack/mutations'
import * as getters from './inventoryRack/getters'

import { dataProps } from './inventoryRack/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryRack.js